import {CourseLivePage} from "@/models/live/courseLivePage";

export type CourseLivePlanStatus = 'NORMAL' | 'READY' | 'ING' | 'END' | 'RETRIEVING' | 'FINISH' | 'DELETE'

export const CourseLivePlanStatusEnums = {
  NORMAL: {text: "未开始", color: '#333333'},
  READY: {text: "即将开始", color: '#F98918'},
  ING: {text: "正在直播", color: '#F98918'},
  END: {text: "已结束", color: '#1881F9'},
  RETRIEVING: {text: "已结束", color: '#1881F9'},
  FINISH: {text: "已结束", color: '#1881F9'},
  DELETE: {text: "删除", color: '#FF0000'}
}

export const FinishedStatus = ['END', 'RETRIEVING', 'FINISH']

export interface CourseLivePlan {
  id: number;
  courseId: number;
  partId: number;
  topic: string;
  teacher: string;
  liveDesc: string;
  openTime: Date;
  endTime: Date;
  status: CourseLivePlanStatus;
  url: string;
  recordedPages: CourseLivePage[];
  previewMaterialsPages: CourseLivePage[];
  instructorCoursewarePages: CourseLivePage[];
  extendedReadingPages: CourseLivePage[];
}
